/** 未完了 TODO の suggestedVenue 一覧を取得する */

import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export const VENUES_KEY = ["venues"] as const;

export const useVenues = () => {
  return useQuery({
    queryKey: VENUES_KEY,
    queryFn: async () => {
      const res = await api.venues.$get();
      if (!res.ok) throw new Error("Failed to fetch venues");
      return res.json();
    },
  });
};
